export default {
  DATE_FORMATS: ['MM-DD-YYYY', 'DD-MM-YYYY', 'MMMM DD YYYY', 'MM/DD/YYYY', 'DD/MM/YYYY'],
};
